import {
  error_something_wrong_sub_text,
  error_something_wrong_text,
} from '@porterin/feature/src/containers/fare-estimate-v1/domain/store/FareEstimateStoreV1';
import {
  error_unserviceable_button_dropoff,
  error_unserviceable_button_dropoff_bn,
  error_unserviceable_button_pickup,
  error_unserviceable_button_pickup_bn,
  error_unserviceable_sub_text_dropoff,
  error_unserviceable_sub_text_dropoff_bn,
  error_unserviceable_sub_text_pickup,
  error_unserviceable_sub_text_pickup_bn,
  error_unserviceable_text,
  error_unserviceable_text_bn,
} from '@porterin/feature/src/shared/core/constants/FareEstimateStore';
import { TextSubtext } from '@porterin/feature/src/shared/types/CommonVM';

const LOCALE_BN_BD = 'bn-BD';

export interface NextImageContent {
  src: string;
  width: number;
  height: number;
  alt: string;
}

export const error_invalid_location: NextImageContent = {
  src: 'https://dom-content-vault-prod-cdn-assets.porter.in/unserviceable_61cacbbd74/unserviceable_61cacbbd74.svg',
  width: 158,
  height: 158,
  alt: 'Map Pin',
};

export const error_something_went_wrong: NextImageContent = {
  src: 'https://dom-content-vault-prod-cdn-assets.porter.in/error_ef88199d3d/error_ef88199d3d.svg',
  width: 150,
  height: 150,
  alt: 'Map Pin',
};

export const error_something_wrong: TextSubtext = {
  text: error_something_wrong_text,
  sub_text: error_something_wrong_sub_text,
};

export function getErrorUnserviceablePickup(
  locale: string | undefined,
): TextSubtext {
  const isBengali = locale === LOCALE_BN_BD;
  return {
    text: isBengali ? error_unserviceable_text_bn : error_unserviceable_text,
    sub_text: isBengali
      ? error_unserviceable_sub_text_pickup_bn
      : error_unserviceable_sub_text_pickup,
  };
}

export function getErrorUnserviceableDropoff(
  locale: string | undefined,
): TextSubtext {
  const isBengali = locale === LOCALE_BN_BD;
  return {
    text: isBengali ? error_unserviceable_text_bn : error_unserviceable_text,
    sub_text: isBengali
      ? error_unserviceable_sub_text_dropoff_bn
      : error_unserviceable_sub_text_dropoff,
  };
}

export function getPickupButtonLabel(locale: string | undefined): string {
  return locale === LOCALE_BN_BD
    ? error_unserviceable_button_pickup_bn
    : error_unserviceable_button_pickup;
}

export function getDropOffButtonLabel(locale: string | undefined): string {
  return locale === LOCALE_BN_BD
    ? error_unserviceable_button_dropoff_bn
    : error_unserviceable_button_dropoff;
}
